module.exports = __webpack_public_path__ + "static/tech-912136e02b1dca92f8dfe832f4a74573.png";